import React from 'react';
import AdminDashboardLayout from '../Common/AdminDashboardLayout/AdminDashboardLayout';
import Calendar from './Calendar';

const CalendarWrapper = () => {
  return (
    // <AdminDashboardLayout>
      <Calendar />
    // </AdminDashboardLayout>
  );
};

export default CalendarWrapper;
